import { Divider, FlexPanel, Link, Text } from 'Common';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getRedirectURLForUpdateEmail } from 'Redux/profile/profileThunks';
import { t } from 'Utils/localization/i18next';
import { showToast } from 'Utils/toastUtils';
import styles from './DashboardSectionReadContainer.module.scss';

class DashboardEmailSectionReadContainer extends React.PureComponent {
  onEdit = async () => {
    const redirectURL = await this.props.getRedirectURLForUpdateEmail();
    if (redirectURL) {
      window.location = redirectURL;
    } else {
      showToast(t('forms.errors.title'), `- ${t('forms.errors.generic')}`);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className={styles['dashboard-section-read']}>
          <FlexPanel spread className={styles['dashboard-section-read-title']}>
            <Text bold colour="grey-900">
              {t(this.props.title)}
            </Text>
            <Link
              bold
              underline
              colour="grey-900"
              id="user-login-ciam-edit-link"
              onClick={this.onEdit}
            >
              {t('common.edit')}
            </Link>
          </FlexPanel>
          {this.props.children}
        </div>
        {!this.props.isLastElement && <Divider dashboard />}
      </React.Fragment>
    );
  }
}

DashboardEmailSectionReadContainer.propTypes = {
  title: PropTypes.string,
  isLastElement: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  // From Redux/Thunks
  getRedirectURLForUpdateEmail: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getRedirectURLForUpdateEmail }, dispatch);
};

export default connect(
  null,
  mapDispatchToProps
)(DashboardEmailSectionReadContainer);
